import React, { PropsWithChildren } from 'react';
import bem from '../../../../../../lib/bemUtils/bem';
import { TooltipPlacement } from '../../../../../atoms/Tooltip';
import { Help } from '../../../../../../_lib/Form2/partials/Help/Help';
import { createDescribedById } from '../../FormLabel/utilities';

type FieldsetLegendProps = {
  className?: string;
  id?: string;
  helpText?: string;
};

export function FieldsetLegend({ children, className, helpText, id }: PropsWithChildren<FieldsetLegendProps>) {
  return (
    <legend className={bem(className || 'form-fieldset__legend')}>
      <span className="form-fieldset__legend-title">
        {children}
        {helpText && id && (
          <Help id={createDescribedById(id)} helpText={helpText} tooltipPlacement={TooltipPlacement.TOP} />
        )}
      </span>
    </legend>
  );
}
